import React from 'react';
import RegisterComponent from '../../components/Layout/Register/Register';

const Register = (): JSX.Element => {
    return <RegisterComponent />;
};

export default Register;
